import _defineProperty from "/root/workspace/OKEY-front_sY8I/node_modules/_@babel_runtime@7.29.2@@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/root/workspace/OKEY-front_sY8I/node_modules/_@babel_runtime@7.29.2@@babel/runtime/helpers/esm/objectSpread2.js";
var _objectSpread2;
import zh_json from './zh.json';
export default _objectSpread((_objectSpread2 = {
  route: {
    dashboard: '首页',
    home: '首页',
    system: '系统管理'
  },
  navbar: {
    logOut: '退出登录',
    profile: '个人资料',
    updatePwd: '修改密码',
    dashboard: '首页',
    github: '项目地址',
    screenfull: '全屏',
    theme: '换肤',
    size: '布局大小'
  },
  login: {
    title: 'OKEY',
    errorAccount: '请输入5到32位的数字和字母',
    errorPassword: '密码至少位5位',
    logIn: '登录',
    username: '账号',
    password: '密码',
    capCode: '验证码'
  },
  button: {
    add: '添加',
    addShop: '新建店铺',
    edit: '修改',
    delete: '删除',
    search: '查询',
    reset: '重置',
    submit: '提交',
    cancel: '取消',
    clear: '清除',
    back: '返回',
    export: '导出',
    save: '保存',
    approve: '审批'
  },
  common: {
    mustSelectOne: '请选中操作项!',
    deleteConfirm: '你确认删除该记录？',
    tooltip: '提示',
    warning: '警告',
    optionSuccess: '操作成功',
    uploadError: '上传文件失败',
    isRequired: '不能为空',
    week: {
      mon: '周一',
      tue: '周二',
      wed: '周三',
      thu: '周四',
      fri: '周五',
      sat: '周六',
      sun: '周日'
    }
  },
  shop: {
    shopName: "店铺名称",
    测试: "1111111111",
    活动标题: "活动标题",
    店铺: "店铺",
    活动内容: "活动内容",
    操作: "操作",
    查看: "查看",
    设备: "设备",
    预约消息: "预约消息",
    预约人: "预约人",
    预约状态: "预约状态",
    待确认: "待确认",
    已确认: "已确认",
    已取消: "已取消"
  },
  店铺名称: "店铺名称",
  店铺LOGO: "店铺Logo",
  店铺地址: "店铺地址",
  营业开始时间: "营业开始时间",
  营业结束时间: "营业结束时间",
  联系电话: "联系电话",
  是否营业中: "是否营业中",
  管理员: "管理员",
  营业执照: "营业执照",
  商铺详情: "商铺详情",
  操作: "操作",
  查看: "查看",
  修改: "修改",
  删除: "删除",
  查看详情: "查看详情",
  盘点单号: "盘点单号",
  盘点仓库: "盘点仓库",
  手机号已经存在: "手机号已存在，请更换手机号",
  添加店铺: "添加店铺",
  无归属人: "无归属人",
  历史归宿人: "历史归宿人",
  历史归属人: "历史归属人",
  有: "有",
  无: "无",
  "有无归属人": "有无归属人",
  "正在运营店铺": "正在运营店铺",
  "全部撤机店铺": "全部撤机店铺",
  "未成交线索": "未成交线索",
  //8.29
  "结算差额": "结算差额",
  "店铺余额": "店铺余额",
  "结算单支付差额": "结算单支付差额",
  //9.2
  "结算信息": "结算信息",
  "欠款金额": "欠款金额",
  "回冲金额": "回冲金额",
  "欠款": "欠款",
  "回冲": "回冲",
  //7.30
  OKR目标: "OKR目标",
  "父任务(履约期目标)": "父任务(履约期目标)",
  "子目标": "子目标",
  "经理名称": "经理名称",
  "代理子账号": "代理子账号",
  "履约日期": "履约日期",
  "履约状态": "履约状态",
  "履约中": "履约中",
  "已锁号": "已锁号",
  "新建目标": "新建目标",
  "子账号": "子账号",
  "签约日期": '签约日期',
  "履约期设备数": "履约期设备数",
  "进度": "进度",
  "目标": "目标",
  "已签约铺设": "已签约铺设",
  "目标名称": "目标名称",
  "目标名称不能为空": "目标名称不能为空",
  "目标接收角色": "目标接收角色",
  "销售经理": "销售经理",
  "运维经理": "运维经理",
  "履约期目标时间": "履约期目标时间",
  "新建线索数": "新建线索数",
  "履约设备数": "履约设备数",
  "目标生成方式": "目标生成方式",
  "父目标分解(履约期任务)": "父目标分解(履约期任务)",
  "子目标时间": "子目标时间",
  "受账单结算周期影响，一周可能存在跨月情况，比如7月第5周跨7月和8月，所以以逻辑月为依据判断": "受账单结算周期影响，一周可能存在跨月情况，比如7月第5周跨7月和8月，所以以逻辑月为依据判断",
  "履约期": "履约期",
  "锁号/已完成": "锁号/已完成",
  "签约设备数": "签约设备数",
  "单台运营时长": "单台运营时长",
  "合同签约后的6个月开始，在任务执行期": "合同签约后的6个月开始，在任务执行期",
  "已完成代表在履约期内任务已完成，达到指定的履约设备数，比如要求100，实际≥100个": "已完成代表在履约期内任务已完成，达到指定的履约设备数，比如要求100，实际≥100个",
  "已锁号代表在履约期内任务未完成，比如要求100，实际完成60": "已锁号代表在履约期内任务未完成，比如要求100，实际完成60",
  "请选择一条信息": "请选择一条信息",
  "延长履约期": "延长履约期",
  "代理员工名称": "代理员工名称",
  "履约效期": "履约效期",
  "yctip": "延长后,则延长的期间内,允许商户下单和运维安装",
  "上调履约设备数": "上调履约设备数",
  "分解目标": "分解目标",
  "最高目标数": "最高目标数",
  "已完成次数": "已完成次数",
  "完成率": "完成率",
  "子目标完成情况": "子目标完成情况",
  "确定延长履约期": "确定延长履约期？？？",
  "修改履约设备数": "修改履约设备数",
  "创建子账号": "创建子账号",
  "履约完成状态": "履约完成状态",
  "确定修改履约设备数": "确定修改履约设备数",
  "履约期目标时间不能为空": "履约期目标时间不能为空",
  "履约设备数不能为空": "履约设备数不能为空",
  "子账号不能为空": "子账号不能为空",
  "提交成功": "提交成功",
  "请选择": "请选择",
  "选择月": "选择月",
  "子目标时间不能为空": "子目标时间不能为空",
  "新建线索数详情": "新建线索数详情",
  "子目标日期": "子目标日期",
  "目标数": "目标数",
  "完成情况": "完成情况",
  "线索名称": "线索名称",
  "线索电话": "线索电话",
  "线索地址": "线索地址",
  "拜访状态": "拜访状态",
  "编辑新建线索数目标": "编辑新建线索数目标",
  "当前单台运营时长/小时": "当前单台运营时长/小时",
  "编辑签约设备数目标": "编辑签约设备数目标",
  "编辑单台运营时长目标": "编辑单台运营时长目标",
  "签约设备数详情": "签约设备数详情",
  "单台运营时长详情": "单台运营时长详情",
  "WAIT_VISITE": "待拜访",
  "IN_DISCUSSION": "商谈中",
  "HAVE_INTENTION": "有意向",
  "DONE_DEAL": "同意签约",
  "DECLINED": "已拒绝",
  "地址": "地址",
  "小时": "小时",
  "新建线索数不能为空": "新建线索数不能为空",
  "签约设备数不能为空": "签约设备数不能为空",
  "单台运营时长不能为空": "单台运营时长不能为空",
  "关联子账号": "关联子账号",
  "跟进次数": "跟进次数",
  "合同编码": "合同编码",
  "合同类型": "合同类型",
  "所属组织": "所属组织",
  "购买": "购买",
  "租赁": "租赁",
  "新建线索数导出xlsx": "新建线索数导出.xlsx",
  "签约设备数导出xlsx": "签约设备数导出.xlsx",
  "单台运营时长导出xlsx": "单台运营时长导出.xlsx",
  "父任务导出xlsx": "父任务导出.xlsx",
  "子目标单台运行时长": "子目标单台运行时长",
  "子任务线索数总和不能大于任务线索数": "子任务线索数总和不能大于任务线索数",
  "子任务设备数总和不能大于任务设备数": "子任务设备数总和不能大于任务设备数",
  "线索存量上限设置": "线索存量上限设置",
  "单个销售专员线索上限数量设置": "单个销售专员线索上限数量设置",
  "温馨说明：设置上限后，则所有销售专员无法超额新建线索；注意：不包含已签约开户的线索，不涉及子账号业务": "温馨说明：设置上限后，则所有销售专员无法超额新建线索；注意：不包含已签约开户的线索，不涉及子账号业务",
  "单个销售专员线索上限数量设置不能为空": "单个销售专员线索上限数量设置不能为空",
  "合同编号": "合同编号",
  "签约金额": "签约金额",
  "合同导出xlsx": "合同导出.xlsx"
}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_objectSpread2, "\u6B63\u5728\u8FD0\u8425\u5E97\u94FA", "正在运营店铺"), "\u5168\u90E8\u64A4\u673A\u5E97\u94FA", "全部撤机店铺"), "\u672A\u6210\u4EA4\u7EBF\u7D22", "未成交线索"), "合同下单时间", "合同下单时间"), "设备安装时间", "设备安装时间"), "合同状态", "合同状态"), "httip", "已签约：合同已签约代表的是合同文件已上传\n" + "\n" + "合作中：代表合同已上传，订单等待安装的过程；\n" + "\n" + "已合作： 代表合同已上传，设备已经铺设；"), "已签约", "已签约"), "合作中", "合作中"), "已合作", "已合作"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_objectSpread2, "运转分析", "运转分析"), "总数", "总数"), "选择运维", "选择运维"), "设备运转良好，暂无空转记录", "设备运转良好，暂无空转记录"), "店铺设备数据详情", "店铺设备数据详情"), "查看明细", "查看明细"), "请输入部门名称", "请输入部门名称")), zh_json);